module.exports = __webpack_public_path__ + "static/media/Sun.96eacd17.webp";